/* eslint-disable lines-between-class-members */
import Enum from './Enum';

class OrderType extends Enum {
  Retail = 0; // 零售
  FnB = 1; // 餐饮
}

export default new OrderType();
